import { render } from "./InvestasiDetailResiko.vue?vue&type=template&id=aead729e"
import script from "./InvestasiDetailResiko.vue?vue&type=script&lang=js"
export * from "./InvestasiDetailResiko.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__